import type { AxiosRequestConfig } from 'axios';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import {
  MarketFacilityFormResponseDtoSchema,
  type MarketFacilityFormResponseDto,
} from '../contracts';

export type PublishMarketFacilityFormResponseDto =
  MarketFacilityFormResponseDto;

export const publishMarketFacilityForm = (
  formId: number,
  config?: AxiosRequestConfig
) => {
  return api
    .post(`/market-facilities/form/${formId}/publish`, undefined, config)
    .then(responseContract(MarketFacilityFormResponseDtoSchema));
};
